export default "| **N-8** | Every save box says who will see a saved report or query, and offers \"just me\" | #1384 | Nov 1 |"